export default function XiaomiLogo() {
  return <img src="/logos/xiaomi-mimo.png" alt="Xiaomi" width="16" height="16" className="block" />
}
